// extracted by mini-css-extract-plugin
export default {"container":"w2-z"};